export default __webpack_public_path__ + "static/media/star-outline.135b0ea3.svg";